import { useCurrentUser } from './useCurrentUser';

/**
 * Authentication hook that provides user authentication status
 *
 * Wrapper around useCurrentUser that exposes authentication state
 * for components that need to check if a user is logged in.
 *
 * @returns Object with isAuthenticated boolean and user info
 *
 * @example
 * const { isAuthenticated, user } = useAuth();
 *
 * if (!isAuthenticated) {
 *   navigate('/login');
 * }
 */
export function useAuth() {
  const currentUser = useCurrentUser();

  return {
    isAuthenticated: currentUser.isAuthenticated,
    user: currentUser.id !== null ? { id: currentUser.id, email: currentUser.email } : null,
    login: () => {
      // Placeholder - actual login handled by LoginPage
    },
    logout: () => {
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_email');
      localStorage.removeItem('token');
      window.location.href = '/login';
    },
  };
}
